export const ACTIVITY_LIST_REQUEST = 'ACTIVITY_LIST_REQUEST';
export const ACTIVITY_LIST_SUCCESS = 'ACTIVITY_LIST_SUCCESS';
export const ACTIVITY_LIST_FAIL = 'ACTIVITY_LIST_FAIL';

export const ACTIVITY_DETAILS_REQUEST = 'ACTIVITY_DETAILS_REQUEST';
export const ACTIVITY_DETAILS_SUCCESS = 'ACTIVITY_DETAILS_SUCCESS';
export const ACTIVITY_DETAILS_FAIL = 'ACTIVITY_DETAILS_FAIL';

export const ACTIVITY_CREATE_REQUEST = 'ACTIVITY_CREATE_REQUEST';
export const ACTIVITY_CREATE_SUCCESS = 'ACTIVITY_CREATE_SUCCESS';
export const ACTIVITY_CREATE_FAIL = 'ACTIVITY_CREATE_FAIL';
export const ACTIVITY_CREATE_RESET = 'ACTIVITY_CREATE_RESET';

export const ACTIVITY_REVIEW_CREATE_REQUEST = 'ACTIVITY_REVIEW_CREATE_REQUEST';
export const ACTIVITY_REVIEW_CREATE_SUCCESS = 'ACTIVITY_REVIEW_CREATE_SUCCESS';
export const ACTIVITY_REVIEW_CREATE_FAIL = 'ACTIVITY_REVIEW_CREATE_FAIL';
export const ACTIVITY_REVIEW_CREATE_RESET = 'ACTIVITY_REVIEW_CREATE_RESET';

export const ACTIVITY_UPDATE_REQUEST = 'ACTIVITY_UPDATE_REQUEST';
export const ACTIVITY_UPDATE_SUCCESS = 'ACTIVITY_UPDATE_SUCCESS';
export const ACTIVITY_UPDATE_FAIL = 'ACTIVITY_UPDATE_FAIL';
export const ACTIVITY_UPDATE_RESET = 'ACTIVITY_UPDATE_RESET';

export const ACTIVITY_DELETE_REQUEST = 'ACTIVITY_DELETE_REQUEST';
export const ACTIVITY_DELETE_SUCCESS = 'ACTIVITY_DELETE_SUCCESS';
export const ACTIVITY_DELETE_FAIL = 'ACTIVITY_DELETE_FAIL';
export const ACTIVITY_DELETE_RESET = 'ACTIVITY_DELETE_RESET';

export const ACTIVITY_CATEGORY_LIST_REQUEST = 'ACTIVITY_CATEGORY_LIST_REQUEST';
export const ACTIVITY_CATEGORY_LIST_SUCCESS = 'ACTIVITY_CATEGORY_LIST_SUCCESS';
export const ACTIVITY_CATEGORY_LIST_FAIL = 'ACTIVITY_CATEGORY_LIST_FAIL';

export const ACTIVITY_WATCHED_REQUEST = 'ACTIVITY_WATCHED_REQUEST';
export const ACTIVITY_WATCHED_SUCCESS = 'ACTIVITY_WATCHED_SUCCESS';
export const ACTIVITY_WATCHED_FAIL = 'ACTIVITY_WATCHED_FAIL';

export const ACTIVITY_COUNTER_REQUEST = 'ACTIVITY_COUNTER_REQUEST';
export const ACTIVITY_COUNTER_SUCCESS = 'ACTIVITY_COUNTER_SUCCESS';
export const ACTIVITY_COUNTER_FAIL = 'ACTIVITY_COUNTER_FAIL';